import React from "react";
import { FaMobileScreen, FaAndroid, FaCode, FaPalette, FaGear, FaCloud } from "react-icons/fa6";
import { Container, H3_SIZE } from "../home/ui";
import { Eyebrow, BlueButton, H2 } from "./mobileUi";

const services = [
  { icon: FaMobileScreen, title: "iOS App Development", text: "Build high-quality native and cross-platform apps for iPhone and iPad.", tone: "bg-[#EEF2FF] text-[#3D5AFE]" },
  { icon: FaAndroid, title: "Android App Development", text: "Create powerful Android apps that deliver seamless performance and great user experiences.", tone: "bg-[#E6F7EE] text-[#16A34A]" },
  { icon: FaCode, title: "Cross-Platform Development", text: "Save time and cost with cross-platform solutions using Flutter & React Native.", tone: "bg-[#E6F3FF] text-[#1E88FF]" },
  { icon: FaPalette, title: "UI/UX Design", text: "Intuitive, modern and engaging designs that users love.", tone: "bg-[#EEEBFF] text-[#5B47F0]" },
  { icon: FaGear, title: "App Maintenance & Support", text: "Keep your app updated, secure and running smoothly.", tone: "bg-[#EEF2FF] text-[#3D5AFE]" },
  { icon: FaCloud, title: "API Integration", text: "Seamless integration with third-party services and custom APIs.", tone: "bg-[#E6F3FF] text-[#1E88FF]" },
];

const MobileServices = () => (
  <section className="bg-[#F7F9FD] py-[48px] lg:py-[64px]">
    <Container className="max-w-[1320px]">
      <div className="grid items-center gap-[36px] lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)] lg:gap-[40px]">
        <div>
          <Eyebrow>Our Mobile App Development Services</Eyebrow>
          <H2 className="mt-[14px]">
            End-to-End Mobile App
            {" "}<br />
            Solutions for Every Business
          </H2>
          <p className="mt-[16px] max-w-[460px] text-[15px] leading-[1.65] text-slate-600 sm:text-[16px]">
            We design and develop feature-rich mobile applications for iOS and Android that are fast, secure and built for
            scale. Whether you need a consumer app or an enterprise solution, we&apos;ve got you covered.
          </p>
          <BlueButton href="/#services" className="mt-[28px]">
            Our Services
          </BlueButton>
        </div>

        <div className="m-swipe grid auto-rows-fr gap-[16px] sm:grid-cols-2 xl:grid-cols-3">
          {services.map((s) => (
            <div
              key={s.title}
              className="h-full min-w-0 rounded-[14px] bg-white p-[20px] shadow-[0_10px_28px_-20px_rgba(15,27,76,0.3)] transition hover:-translate-y-1"
            >
              <span className={`inline-flex h-[44px] w-[44px] items-center justify-center rounded-[10px] text-[20px] ${s.tone}`}>
                <s.icon />
              </span>
              <h3 className={`mt-[16px] font-semibold text-[#0F1B4C] ${H3_SIZE}`}>{s.title}</h3>
              <p className="mt-[8px] text-[13.5px] leading-[1.6] text-slate-500">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default MobileServices;
